import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_DATA_SEARCH_CONTRACT_COMPLAINTS } from './constant/emptyData';

const initialState = {
    search: {
        ...EMPTY_DATA_SEARCH_CONTRACT_COMPLAINTS
    }
};

export const contractComplaintsSlice = createSlice({
    name: 'contractComplaints',
    initialState,
    reducers: {
        searchContractComplaints: (state, action) => {
            state.search = action.payload;
        },
        searchContractComplaintsPageFirst: (state, action) => {
            state.search.page = 1;
        },
    },
})


// Action creators are generated for each case reducer function
const { reducer, actions } = contractComplaintsSlice;
export const { searchContractComplaints, searchContractComplaintsPageFirst } = actions

export const selectSearchContractComplaints = (state) => state?.features?.contractComplaints?.search

export default reducer


